<template>
  <div id="screen">
    <div class="left">
      <p v-for="(line, row) in lines" :key="row">
        <Digit v-for="(c, column) in line" :value="c" :loop="true" :key="column" />
        <Digit v-for="(c, column) in 30" value=" " :key="column" />
      </p>
    </div>
    <div class="right">
      <textarea v-model="text"></textarea>
    </div>
  </div>
</template>

<script>
  import Digit from './Digit.vue'

  export default {
    data: function() {
      return {
        text: 'screen\n.dev\n123456789\n:-)\n\n\n\n\n\n\n'
      }
    },
    computed: {
      lines: function() {
        return this.text.split("\n");
      }
    },
    components: {
      Digit
    }
  }
</script>

<style scoped>
  #screen {
    font-size: 120px;
  }

  .left {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;

    overflow-x: hidden;
    overflow-y: scroll;

    white-space: nowrap;
  }

  .right {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;

    width: 3em;
  }

  p {
    margin: 0;
  }

  textarea {
    width: 100%;
    height: 100%;

    background-color: #333;
    color: white;
    font-size: 30px;
    font-family: monospace;

    border: none;
    border-radius: 0;
    border-left: 2px solid #666;

    padding-left: 30px;
    padding-top: 20px;

    z-index: 100;
  }

  textarea:focus {
    outline: none;
  }

</style>
